module.exports = __webpack_public_path__ + "static/img/card_img_01.c16bab58.jpg";